import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ChaveValor } from '../../../../interfaces/segmentacao/chave-valor.interface';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SegmentacaoService } from '../../../../services/segmentacao.service';
import { TipoFiltro } from '../../../../enums/tipo-filtro.enum';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-filtro-pesquisavel',
    templateUrl: './filtro-pesquisavel.component.html',
    styleUrls: ['./filtro-pesquisavel.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FiltroPesquisavelComponent implements OnInit {
    @Input() titulo: string = '';
    @Input() tipoFiltro!: TipoFiltro;
    @Input() itensSelecionados: ChaveValor[] = [];
    @Input() propriedadeDestino!: keyof any;

    @Output() salvar = new EventEmitter<ChaveValor[]>();
    @Output() cancelar = new EventEmitter<void>();

    pesquisa$ = new Subject<string>();
    loading: boolean = false;
    opcoesDisponiveis: ChaveValor[] = [];
    itensSelecionadosInterno: ChaveValor[] = [];

    constructor(private segmentacaoService: SegmentacaoService, private cdr: ChangeDetectorRef, private toastr: ToastrService) { }

    ngOnInit(): void {
        this.itensSelecionadosInterno = this.itensSelecionados;
        this.pesquisa$.pipe(
            debounceTime(300),
            distinctUntilChanged()
        ).subscribe(async (termo) => {
            await this.buscarFiltro(termo);
        });

        this.carregarOpcoes();
    }

    async buscarFiltro(termo: string): Promise<void> {
        this.loading = true;
        const data = await this.segmentacaoService.buscarFiltro({ tipo: this.tipoFiltro, filtro: termo });
        this.opcoesDisponiveis = data?.filter(opcao =>
            !this.itensSelecionadosInterno.some(item => item.chave === opcao.chave)
        ) || [];
        this.loading = false;
    }

    async carregarOpcoes(): Promise<void> {
        this.loading = true;
        const data = await this.segmentacaoService.listarFiltro({ tipo: this.tipoFiltro, qtdeRegistros: 10 });
        this.opcoesDisponiveis = data || [];
        this.loading = false;
    }

    adicionarFiltro(item: ChaveValor): void {
        if (!item) return;

        if (!this.itensSelecionadosInterno.some(i => i.chave === item.chave)) {
            this.itensSelecionadosInterno.push(item);
            this.opcoesDisponiveis = this.opcoesDisponiveis.filter(opcao => opcao.chave !== item.chave);
        }
    }

    removerFiltro(item?: ChaveValor, removerTodos: boolean = false): void {
        if (removerTodos) {
            this.itensSelecionadosInterno = [];
            this.opcoesDisponiveis = [...this.opcoesDisponiveis, ...this.itensSelecionadosInterno];
        } else {
            if (!item) return;
            this.itensSelecionadosInterno = this.itensSelecionadosInterno.filter(f => f.chave !== item?.chave);
            this.opcoesDisponiveis = [...this.opcoesDisponiveis, item];
        }
    }

    salvarFiltro(): void {
        this.salvar.emit(this.itensSelecionadosInterno);
    }

    cancelarFiltro(): void {
        this.itensSelecionadosInterno = [...this.itensSelecionados];
        this.cancelar.emit();
    }
}
